import type {StateCreator} from 'zustand'

export type MarkerCountsActions = {
  hydrateMarkerCounts: (counts: {annotationsCount?: number}) => void
}

export type MarkerCountsSlice = {
  /** Server-provided annotations count. Null before the marker counts request resolves. */
  annotationsCount: number | null
  markerCountsActions: MarkerCountsActions
}

export const createMarkerCountsSlice =
  (): StateCreator<MarkerCountsSlice, [['zustand/devtools', never]], [], MarkerCountsSlice> => set => ({
    annotationsCount: null,
    markerCountsActions: {
      hydrateMarkerCounts: ({annotationsCount}) => {
        set(
          {
            ...(annotationsCount !== undefined && {annotationsCount}),
          },
          undefined,
          'hydrateMarkerCounts',
        )
      },
    },
  })
